// also may try this... https://mathjs.org/index.html
// or this!  https://thisancog.github.io/statistics.js/inc/distributions.html

export const fMean = (array) => {
  if (array && array.length > 0) {
    let u = array.reduce((a, v) => a + v) / array.length;
    return u;
  } else {
    return false;
  }
};

//zingi: https://stackoverflow.com/questions/7343890/standard-deviation-javascript
export function fStdDev(array) {
  if (array && array.length > 0) {
    const n = array.length;
    const mean = array.reduce((a, b) => a + b) / n;
    return Math.sqrt( array.map((x) => Math.pow(x - mean, 2)).reduce((a, b) => a + b) / n );
  }else{
    return false;
  }

}

// Based on definition of 3rd moment
export function fSkewness(array) {
  const n = array.length;
  const mean = array.reduce((a, b) => a + b) / n;
  const numer = array.map((x) => Math.pow(x - mean, 3)).reduce((a, b) => a + b) / n;
  const denom = fStdDev(array);
  return numer / Math.pow(denom, 3);
}

export function fKurtosis(array) {
  const n = array.length;
  const mean = array.reduce((a, b) => a + b) / n;
  const numer = array.map((x) => Math.pow(x - mean, 4)).reduce((a, b) => a + b) / n;
  const denom = fStdDev(array);
  return numer / Math.pow(denom, 4);
}

//https://www.w3resource.com/javascript-exercises/fundamental/javascript-fundamental-exercise-88.php
export const fMedian = (arr) => {
  const mid = Math.floor(arr.length / 2),
    nums = [...arr].sort((a, b) => a - b);
  return arr.length % 2 !== 0 ? nums[mid] : (nums[mid - 1] + nums[mid]) / 2;
};

// buboh: https://stackoverflow.com/questions/48719873/how-to-get-median-and-quartiles-percentiles-of-an-array-in-javascript-or-php
export const fQuantile = (arr, q) => {
  const sorted = [...arr].sort((a, b) => a - b);
  const pos = (sorted.length - 1) * q;
  const base = Math.floor(pos);
  const rest = pos - base;
  if (sorted[base + 1] !== undefined) {
    return sorted[base] + rest * (sorted[base + 1] - sorted[base]);
  } else {
    return sorted[base];
  }
};

// Bok-Mueller Transform
// https://spin.atomicobject.com/2019/09/30/skew-normal-prng-javascript/
// const randomNormals = (rng) => {
//   let u1 = 0,
//     u2 = 0;
//   //Convert [0,1) to (0,1)
//   while (u1 === 0) u1 = rng();
//   while (u2 === 0) u2 = rng();
//   const R = Math.sqrt(-2.0 * Math.log(u1));
//   const Θ = 2.0 * Math.PI * u2;
//   return [R * Math.cos(Θ), R * Math.sin(Θ)];
// };

// Ian H: https://stackoverflow.com/questions/5259421/cumulative-distribution-function-in-javascript
export function nCDF(x, mean, std) {
  var z = (x - mean) / std;
  var t = 1 / (1 + 0.2315419 * Math.abs(z));
  var d = 0.3989423 * Math.exp((-z * z) / 2);
  var prob = d * t * (0.3193815 + t * (-0.3565638 + t * (1.781478 + t * (-1.821256 + t * 1.330274))));
  //if( z > 0 ) prob = 1 - prob
  if (z < 0) prob = 1 - prob;
  return prob;
}

// const fSum = (array) => array.reduce((a, b) => a + b);
// https://www.geeksforgeeks.org/how-to-get-the-standard-deviation-of-an-array-of-numbers-using-javascript/

// https://leancrew.com/all-this/2020/06/ordinal-numerals-and-javascript/
export function ordinal(n) {
  var s = ["th", "st", "nd", "rd"];
  var v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
}


// From Google AI search 'javascript calculate mean absoloute deviation'
export function calculateMAD(data) {
  if (!data || data.length === 0) {
    return 0; // Handle empty or invalid input
  }

  // Calculate the mean
  const sum = data.reduce((acc, val) => acc + val, 0);
  const mean = sum / data.length;

  // Calculate absolute deviations
  const absoluteDeviations = data.map(val => Math.abs(val - mean));

  // Calculate the mean of absolute deviations
  const madSum = absoluteDeviations.reduce((acc, val) => acc + val, 0);
  const mad = madSum / absoluteDeviations.length;

  return mad;
}

// From Google AI search 'javascript calculate autocorrelation'
export function autocorrelation(data, lag) {
  const n = data.length;
  if (n <= lag) {
    return 0;
  }

  let mean = data.reduce((sum, val) => sum + val, 0) / n;
  let numerator = 0;
  let denominator = 0;

  for (let i = 0; i < n - lag; i++) {
      numerator += (data[i] - mean) * (data[i + lag] - mean);
      denominator += Math.pow(data[i] - mean, 2);
  }

    if (denominator === 0) return 0;
  return numerator / denominator;
}

// From Google AI search 'javascrip durbin-watson statistic'
export function durbinWatson(residuals) {
  let sumOfSquaredDifferences = 0;
  let sumOfSquaredResiduals = 0;

  for (let i = 1; i < residuals.length; i++) {
    sumOfSquaredDifferences += Math.pow(residuals[i] - residuals[i - 1], 2);
  }

  for (let i = 0; i < residuals.length; i++) {
    sumOfSquaredResiduals += Math.pow(residuals[i], 2);
  }

  return sumOfSquaredDifferences / sumOfSquaredResiduals;
}

// Adapted from a Google AI search 
export function simpleExponentialSmoothing(data, alpha) {
  if (!data || data.length === 0) {
    return [];
  }

  const smoothedValues = [];
  let lastSmoothedValue = data[0]; // Initialize with first data point

  smoothedValues.push(lastSmoothedValue);

  for (let i = 1; i < data.length; i++) {
    const smoothedValue = alpha * data[i] + (1 - alpha) * lastSmoothedValue;
    smoothedValues.push(smoothedValue);
    lastSmoothedValue = smoothedValue;
  }
  return smoothedValues;
}

// From Google AI search, 'javascript calculate RMSE'
export function calculateRMSE(actual, predicted) {
  if (actual.length !== predicted.length) {
    throw new Error("Arrays must be of the same length. Arg1 length= " + actual.length + ", Arg2 length= " + predicted.length);
  }

  const n = actual.length;
  let sumOfSquaredErrors = 0;

  for (let i = 0; i < n; i++) {
    const error = actual[i] - predicted[i];
    sumOfSquaredErrors += error * error;
  }

  const meanSquaredError = sumOfSquaredErrors / n;
  const rmse = Math.sqrt(meanSquaredError);

  return rmse;
}


  export function findSESOptimalAlpha(timeSeriesData){

    if(!timeSeriesData || timeSeriesData === false || timeSeriesData.length === 0){
      return 0.618
    }

    let optimalAlpha = 0.618; // default
    let minRMSE = Number.MAX_VALUE;

    for(let alpha = 0.01; alpha <= 0.99; alpha+=0.01){
      let x = [...timeSeriesData]; //shallow copy via spread operator
      let y = simpleExponentialSmoothing(x, alpha);
      //console.log(x.length + " vs " + timeData.toReversed().length)
      let rmse = calculateRMSE(x.slice(1,x.length),  y.slice(0,y.length-1));
      if(rmse < minRMSE){
        minRMSE = rmse
        optimalAlpha = alpha
      }
    }
    return optimalAlpha;

  }